import React from 'react'
import { ReceiptCard, styled } from '~/app/components'
import InformationPanel, {
  InformationFormat,
} from '~/app/components/order-list/details/InformationPanel'
import SubHeader from '../../common/SubHeader/SubHeader'

/**
 * PaymentInformation component
 * author: soojin.oh
 */

// type definitions
type PaymentInformationProps = {
  payment: Array<InformationFormat>
  isReceiptCard?: boolean
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'style'>

// styled components
const Container = styled.div`
  position: relative;
  background: ${({ theme }) => theme.color.white};
  padding-bottom: 2rem;
`

const PaymentCard = styled(props => <ReceiptCard {...props} />)`
  margin-top: 0;
`

// PaymentInformation component
const PaymentInformation: React.FunctionComponent<PaymentInformationProps> = function ({
  payment,
  style,
  isReceiptCard,
}) {
  return isReceiptCard ? (
    <PaymentCard title="결제 금액" isDisabledViewDetail={isReceiptCard}>
      <InformationPanel information={payment} />
    </PaymentCard>
  ) : (
    <Container style={style}>
      <SubHeader title="결제 금액" hasBottomContent />
      <InformationPanel information={payment} />
    </Container>
  )
}

export default PaymentInformation
